<div class="webcam-container" [style.display]="webcameIsInit && showWebcam && deviceReady ? 'flex' : 'none'">
  <div id="webcam" [style.border-color]="documentCapture ? 'transparent' : borderColor" [style.border-width]="documentCapture ? '0px' : '5px'" [style.aspect-ratio]="effectiveAspectRatio">
    <div class="broken-button fullWidth" *ngIf="brokenButton">
      <app-button size="sm" color="red" (click)="problemManualCamera()" [matTooltip]="'tooltip.webcamProblems' | translate">{{'camera.problem.button' | translate}}</app-button>
      <div class="f_grow f_end fullWidth" >
        <div class="offline_warn" *ngIf="showOfflineWarning">
          <fa-icon icon="triangle-exclamation"></fa-icon>
          <span [innerHtml]="'payment_status.desc.offlineApplication' | translate"></span>
        </div>
      </div>
    </div>
    <div id="scanner_placeholder" [style.display]="webcameIsInit && showWebcam && deviceReady ? 'block' : 'none'" *ngIf="showWebcam && deviceReady">
      <div class="scanner_square" *ngIf="!documentCapture"></div>
      <div class="scanner_bottom">
        <app-back-btn color="none" [shortcut]="ShortcutAction.ESCAPE" (click)="backUrlRedirect(backUrl)"></app-back-btn>
        <span id="takeScreenshot" [shortcut]="ShortcutAction.ENTER" (click)="triggerSnapshot()" [class.disabled]="!documentCapture && !canCapture"><span></span></span>
        <div class="flex">
          <fa-icon *ngIf="multipleWebcamsAvailable" class="scanner_camera" icon="camera-rotate" (click)="showNextWebcam(true)"></fa-icon>
          <fa-icon *ngIf="canRotateCamera" class="scanner_camera" icon="rotate-right" (click)="rotateCamera()"></fa-icon>
        </div>
      </div>
    </div>
    <webcam id="webcam_element" [style.display]="webcameIsInit && showWebcam && deviceReady && ratioDetected ? 'flex' : 'none'" [style.justify-content]="'center'" *ngIf="showWebcam" [hidden]="!webcameIsInit"
            [trigger]="triggerObservable"
            [allowCameraSwitch]="false"
            [switchCamera]="nextWebcamObservable"
            [videoOptions]="videoOptions"
            [imageQuality]="imageQuality"
            [videoInitialized]="videoInitialized"
            mirrorImage="never"
            (imageCapture)="handleImage($event)"
            (cameraSwitched)="cameraWasSwitched($event)"
            (initError)="handleInitError($event)"
            [ngClass]="rotationClass"
    ></webcam>
  </div>
</div>
